/* eslint-disable no-inline-comments */
/* eslint-disable lines-around-comment */
import Dropdown from './Dropdown'
import FilterProducts from './FilterProducts'
import ProductGallery from './ProductGallery'
import Products from './Products'
import ProductTabs from './ProductTabs'
import Slider from './Slider'
import SocialMedia from './SocialMedia'
import List from './List'
import Tab from './Tab'
import Madlib from './Madlib'
import Section from './Section'
import Brand from './Brand'
import Video from './Video'
/* generated script here */

const blockList = [{
    name: 'social-media',
    Class: SocialMedia
  },
  {
    name: 'single-product__tabs',
    Class: ProductTabs
  },
  {
    name: 'single-product__gallery',
    Class: ProductGallery
  },
  {
    name: 'dropdown',
    Class: Dropdown
  },
  {
    name: 'b-slider',
    Class: Slider
  },
  {
    name: 'shop__list',
    Class: FilterProducts
  },
  {
    name: 'b-products',
    Class: Products
  },
  {
    name: 'b-list',
    Class: List
  },
  {
    name: 'b-tab',
    Class: Tab
  },
  {
    name: 'b-madlib',
    Class: Madlib
  },
  {
    name: 'app',
    Class: Section
  }, {
    name: 'catalog-brand',
    Class: Brand
  }, {
    name: 'b-video',
    Class: Video
  } /* generated class */
]

export default blockList



// WEBPACK FOOTER //
// ./scripts/blocks/blockList.js